<template>
  <pict
    class="join-confirm-email-image__image"
    block-name="join-confirm-email-image"
    :modifiers="['rendering-pixelated']"
    :default="imageProps.default"
    :sources="imageProps.sources"
    :alt="$t('alt')"
  />
</template>

<script>
import Pict from "@/shared/pict"

import imageL from "./images/desktop.png"
import imageL2x from "./images/desktop@2x.png"
import imageM from "./images/tablet.png"
import imageM2x from "./images/tablet@2x.png"
import imageS from "./images/mobile.png"
import imageS2x from "./images/mobile@2x.png"

export default {
  name: "ConfirmEmailImage",
  components: {
    Pict
  },
  computed: {
    imageProps() {
      return {
        default: {
          src: imageL,
          srcset: {
            "2x": imageL2x
          }
        },
        sources: [
          {
            media: "s",
            src: imageS,
            srcset: {
              "2x": imageS2x
            }
          },
          {
            media: "m",
            src: imageM,
            srcset: {
              "2x": imageM2x
            }
          }
        ]
      }
    }
  },
  i18n: {
    messages: {
      en: {
        alt: "A group of people holding a banner saying 'Welcome'"
      },
      de: {
        alt: "Eine Gruppe von Personen hält ein Banner mit der Aufschrift 'Willkommen'."
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.confirm-email-image {
  ::v-deep &__image {
    width: 100%;
  }
}
</style>
